export default [
    {
        category: "sustainabilityCause",
        cause: "climateChange"
    },
    {
        category: "socialCause",
        cause: "women"
    },
    {
        category: "drugsCause",
        cause: "tobacco"
    },
    {
        category: "peaceCause",
        cause: "military"
    },
    {
        category: "socialCause",
        cause: "lgbt"
    },
    {
        category: "foodCause",
        cause: "sugar"
    },
    {
        category: "foodCause",
        cause: "vegan"
    },
];
